import { useMemo } from 'react';
import PropTypes from 'prop-types';
import TablaLocal from '../tabla/TablaLocal';

const COLUMNAS = [
  { id: 'id', label: 'ID', width: 80, sortable: true, filter: 'text' },
  { id: 'empresaId', label: 'Empresa', width: 120, sortable: true, filter: 'multi' },
  { id: 'ciclo', label: 'Ciclo', width: 160, sortable: true, filter: 'multi' },
  { id: 'nombre_alumno', label: 'Alumno', width: 220, sortable: true, filter: 'text' },
  { id: 'email_tut1', label: 'Email tutor 1', width: 220, sortable: true, filter: 'text' },
  { id: 'nombre_tut1', label: 'Nombre tutor 1', width: 200, sortable: true, filter: 'text' },
  { id: 'email_tut2', label: 'Email tutor 2', width: 220, sortable: true, filter: 'text' },
  { id: 'nombre_tut2', label: 'Nombre tutor 2', width: 200, sortable: true, filter: 'text' },
];

const TablaTutores = ({ data, selected, onCheckboxChange, onSeleccionarVarias }) => {
  const seleccion = useMemo(() => {
    const ids = new Set((selected || []).map((s) => s.id));
    return {
      estaSeleccionada: (fila) => ids.has(fila.id),
      alternar: (fila) => onCheckboxChange?.(fila),
      alternarTodas: (filas, marcar) => onSeleccionarVarias?.(filas, marcar),
    };
  }, [selected, onCheckboxChange, onSeleccionarVarias]);

  return (
    <TablaLocal
      tablaKey="boletines"
      columnas={COLUMNAS}
      filas={data || []}
      nombreEntidad="tutores"
      archivo="boletines-tutores"
      placeholder="Buscar alumno, tutor o email…"
      seleccion={seleccion}
      claveFila={(fila) => fila.id}
      tituloTarjeta={(fila) => fila.nombre_alumno || String(fila.id)}
    />
  );
};

TablaTutores.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.array,
  onCheckboxChange: PropTypes.func,
  onSeleccionarVarias: PropTypes.func,
};

export default TablaTutores;
